import { React, useState } from "react";
import Fade from "@mui/material/Fade";
import { Box, IconButton, Popper, Typography, ClickAwayListener } from "@mui/material";
import { BsThreeDots } from "react-icons/bs";
import { IoClose } from "react-icons/io5";
import { MdOutlineError } from "react-icons/md";

function ErrorMessage({ message = "", messages = [] }) {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const canBeOpen = open && Boolean(anchorEl);
  const id = canBeOpen ? "transition-popper" : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((prev) => !prev);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  return (
    <Box
      width="100%"
      bgcolor="#D65745"
      sx={{ boxSizing: "border-box" }}
      py={0.8}
      px={1.5}
      borderRadius={3}
      my={1}
    >
      <Box display="flex" justifyContent="space-between">
        <IconButton aria-describedby={id} onClick={handleClick}>
          {open ? (
            <IoClose color="#fff" fontSize="100%" />
          ) : (
            <BsThreeDots color="#fff" fontSize="100%" />
          )}
        </IconButton>
        <Box display="flex" flexDirection="row-reverse">
          <Box display="flex" justifyContent="center" alignItems="center">
            <Typography variant="h2" color="#fff" mr={1} textAlign="justify">
              {message}
            </Typography>
            <MdOutlineError
              color="#fff"
              size={23}
              style={{ minWidth: "1.3rem", minHeight: "1.3rem" }}
            />
          </Box>
        </Box>
      </Box>
      <Popper id={id} open={open} anchorEl={anchorEl} transition>
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClose}>
            <Fade
              {...TransitionProps}
              timeout={350}
              borderRadius={3}
              ml={3}
              mt={1}
              width={{ xs: "70%", md: "90%" }}
              maxWidth="350px"
              maxHeight="21rem"
              sx={{
                border: "none",
                color: "#4C466F",
                background: "#ffffff",
                boxShadow: "0.5px 0.5px 18px #aaaaaa8f",
                overflow: "auto",
              }}
            >
              <Box padding="1rem 1rem 1rem 0" sx={{ p: 1, bgcolor: "background.paper" }}>
                {messages.map(({ errorMessages, pageCode }, i) => {
                  return (
                    <Box key={i} paddingBottom="1rem">
                      {Object.keys(errorMessages)?.length !== 0 && (
                        <Typography sx={{ direction: "rtl", textAlign: "justify" }}>
                          {pageCode !== undefined && PAGECO_DEDECTIONARY[pageCode]}
                        </Typography>
                      )}
                      <Box mr={2}>
                        {Object.keys(errorMessages).map((key, j) => {
                          return (
                            <Typography
                              key={j}
                              sx={{ direction: "rtl", textAlign: "justify", paddingLeft: "1rem" }}
                            >
                              {errorMessages[key]}
                            </Typography>
                          );
                        })}
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    </Box>
  );
}

export default ErrorMessage;

const PAGECO_DEDECTIONARY = {
  1: "اطلاعات پایه",
  2: "اطلاعات شخصی",
  3: "اطلاعات خانوادگی",
  4: "اطلاعات تحصیلی",
  5: "اطلاعات اقتصادی",
  6: "خواسته های من",
  7: "بارگذاری مدرک",
};
